import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  host: {
    'data-component': 'button',
  },
})
export class ButtonComponent {
  @Input() label = '';
  @Input() severity:
    | 'success'
    | 'info'
    | 'warn'
    | 'primary'
    | 'help'
    | 'danger'
    | 'secondary'
    | 'contrast' = 'primary';
  @Input() sizeClass: 'p-button-sm' | 'p-button-md' | 'p-button-lg' =
    'p-button-sm';
  @Input() iconStart = '';
  @Input() iconEnd = '';
  @Input() rounded = false;
  @Input() textButton = false;
  @Input() outlinedButton = false;
  @Input() disabled = false;
  @Input() isLoading = false;

  @Input() iconOnlyButton = false;
  @Input() icon: string | undefined = undefined; // used only with the icon only button

  @Output() onClick = new EventEmitter();
}
